import axios from "axios";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";

function UpdateEwayBillLogin({
  deliveryewaybill = null,
  ewaybillLogin = null,
  flag = "",
  setTaxVisible = () => {},
  setdeliVisible = () => {},
}) {
  const [visible, setVisible] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  let navigate = useNavigate();
  console.log(flag);

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  useEffect(() => {
    console.log(ewaybillLogin);
    console.log(deliveryewaybill);
    if (flag === "taxinvoice") {
      formik.setValues({
        username: ewaybillLogin?.username,
        password: ewaybillLogin?.password,
      });
    }
    if (flag === "deliverychallan") {
      formik.setValues({
        username: deliveryewaybill?.username,
        password: deliveryewaybill?.password,
      });
    }
  }, [ewaybillLogin, deliveryewaybill]);

  const validationSchema = Yup.object().shape({
    username: Yup.string().required("Username is required"),
    password: Yup.string().required("Password is required"),
  });

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleFormSubmit(values);
    },
  });
  const handleFormSubmit = (values) => {
    console.log(values);
    if (flag === "taxinvoice") {
      axios
        .put(
          "/api/purple-fusion/ewaybill/login/taxinvoice/update",
          values,
          headers
        )
        .then((response) => {
          const message = response.data.message;
          response.data.status
            ? toast.success(message, {
                autoClose: 2000,
                onClose: () => {
                  setVisible(false);
                  setTaxVisible(false);
                  setdeliVisible(false);
                  //   navigate("/ewaybill/login");
                },
              })
            : toast.error(message, {
                autoClose: 2000,
              });
        })
        .catch((error) => {
          setVisible(false);
          console.log(error);
          navigate("*");
        });
    }
    if (flag === "deliverychallan") {
      axios
        .put(
          "/api/purple-fusion/ewaybill/login/deliverychallan/update",
          values,
          headers
        )
        .then((response) => {
          const message = response.data.message;
          response.data.status
            ? toast.success(message, {
                autoClose: 2000,
                onClose: () => {
                  setVisible(false);
                  setTaxVisible(false);
                  setdeliVisible(false);
                  //   navigate("/ewaybill/login");
                },
              })
            : toast.error(message, {
                autoClose: 2000,
              });
        })
        .catch((error) => {
          setVisible(false);
          console.log(error);
          navigate("*");
        });
    }

    // console.log(values);
  };

  const customStyle = {
    content: {
      width: "40%",
      height: "60%",
      margin: "auto",
      borderRadius: "15px",
      padding: "2rem",
      boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
    },
    overlay: { backgroundColor: "rgba(0, 0, 0, 0.6)" },
  };

  return (
    <div>
      <Modal
        isOpen={visible}
        style={customStyle}
        // onRequestClose={() => setVisible(false)}
      >
        <div className="flex flex-col space-y-6">
          <ToastContainer />
          <div className="flex justify-between items-center">
            <h2 className="text-2xl font-semibold"> Update EwayBill Login</h2>
            <button
              className="text-gray-600 hover:text-gray-800"
              onClick={() => {
                setVisible(false);
                setTaxVisible(false);
                setdeliVisible(false);
                // navigate("/ewaybill/login");
              }}
            >
              ╳
            </button>
          </div>

          <form onSubmit={formik.handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">
                Username <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  type="text"
                  name="username"
                  placeholder="Enter your username"
                  value={formik.values.username}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="w-full border rounded-lg py-2 px-3 shadow-sm focus:ring-blue-500 focus:border-blue-500"
                />
                {formik.touched.username && formik.errors.username && (
                  <p className="text-red-500 text-xs mt-1">
                    {formik.errors.username}
                  </p>
                )}
              </div>
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">
                Password <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Enter your password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="w-full border rounded-lg py-2 px-3 shadow-sm focus:ring-blue-500 focus:border-blue-500 pr-10"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-3 flex items-center text-gray-500"
                >
                  {showPassword ? (
                    <AiOutlineEyeInvisible size={20} />
                  ) : (
                    <AiOutlineEye size={20} />
                  )}
                </button>
                {formik.touched.password && formik.errors.password && (
                  <p className="text-red-500 text-xs mt-1">
                    {formik.errors.password}
                  </p>
                )}
              </div>
            </div>

            <div className="flex justify-end space-x-4">
              <button
                type="submit"
                className="bg-blue-500 text-white-A700 px-4 py-2 rounded-lg shadow hover:bg-blue-600"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
}

export default UpdateEwayBillLogin;
